import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7sthum5n64: FaireBrandEntity = {
  token: "b_7sthum5n64",
  type: "brand",
  name: "KOYD",
  avatarUrl:
    "https://cdn.faire.com/fastly/3806f66fc1175c60bd8cf97c3320ddb73d0a369aec79aa1cfc6f02f33a5b442e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/70f4abd49dc0d281621e391ce2ea4f71125b646c49ae191c641c69bdd661e957.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3806f66fc1175c60bd8cf97c3320ddb73d0a369aec79aa1cfc6f02f33a5b442e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/70f4abd49dc0d281621e391ce2ea4f71125b646c49ae191c641c69bdd661e957.jpeg",
  location: "Sacramento, CA, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "KOYD began because I wanted to combine my two favorite hobbies into one: fragrance and reading.\n\nI've been an avid fragrance enthusiast for my entire life, from candles to colognes. The more I dived into the world of niche fragrances, the more difficulty I had in finding a candle with depth.\n\nAs any reader knows,  a good book fully immerses you in a new place, a new story, or even a new feeling. So I wanted a candle that could do the same — that way, the second you light it, you’re not in your living room anymore.",
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:41.715Z",
    importedBy: "entity-db-cli",
  },
};
